export default __webpack_public_path__ + "img/ng100.a2f965d3.jpg";